(function() {
    'use strict';
    angular
        .module('functional7App')
        .factory('Programa', Programa);

    Programa.$inject = ['$resource', 'DateUtils'];

    function Programa ($resource, DateUtils) {
        var resourceUrl =  'api/programas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.modificado = DateUtils.convertLocalDateFromServer(data.modificado);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.modificado = DateUtils.convertLocalDateToServer(copy.modificado);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.modificado = DateUtils.convertLocalDateToServer(copy.modificado);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
